import React, { Fragment, useState } from 'react';
import Card from '@Utils/Card';
import { Button, Checkbox, Modal, Radio, Space } from 'antd';
import {
  DeleteOutlined,
  FormOutlined,
  PlusCircleOutlined,
} from '@ant-design/icons';
import SurveyQuestionModalContent from './surveyQuestionModalContent';
import './surveyBaseStyles.scss';
import './addQuestion.scss';
import { showMessage } from '@Utils/RenderUtils';

function QuestionList(props) {
  return (
    <div className="question-list">
      {props.data.map((item, index) => (
        <div key={index} className="question-item">
          <div className="question-body">
            <span>{item.body ?? ''}</span>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <FormOutlined
                onClick={props.onClick}
                style={{ cursor: 'pointer' }}
              />
              {props.data.length > 1 && (
                <DeleteOutlined
                  onClick={() => props.onRemove(item.id, index)}
                  style={{ cursor: 'pointer' }}
                />
              )}
            </div>
          </div>
          {item.question?.multipleSelection ? (
            <Space
              wrap
              size="middle"
              direction={(
                item.question.displayDirection ?? 'HORIZONTAL'
              ).toLowerCase()}
            >
              {(item.question?.options || []).map((option) => (
                <Checkbox value={option} key={option}>
                  {option}
                </Checkbox>
              ))}
            </Space>
          ) : (
            <Radio.Group>
              <Space
                wrap
                size="middle"
                direction={(
                  item.question?.displayDirection ?? 'HORIZONTAL'
                ).toLowerCase()}
              >
                {(item.question?.options || []).map((option) => (
                  <Radio value={option} key={option}>
                    {option}
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
          )}
        </div>
      ))}
    </div>
  );
}

function QuestionAddButton(props) {
  return (
    <div
      style={{
        paddingInline: 24,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
      }}
    >
      <span>Questions</span>
      <Button
        style={{ minWidth: 300, padding: 0 }}
        icon={<PlusCircleOutlined />}
        onClick={props.onClick}
      >
        <div>Add Question</div>
      </Button>
    </div>
  );
}

function AddQuestion(props) {
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);

  const [tempQuestions, setTempQuestions] = useState(props?.value || []);

  function removeQuestion(id, index) {
    let filtered = tempQuestions.filter((q) => q?.id !== id);

    if (tempQuestions.length === filtered.length) {
      filtered = filtered.filter((_, i) => i !== index);
    }

    setTempQuestions(filtered);

    props.restoreQuestions(filtered);

    props.partialUpdateQuestions(() => {
      showMessage('The question has deleted successfully', 'success');
    });
  }

  return (
    <Fragment>
      <Card>
        <div className="question-header">
          <span className="section-title">Question</span>
        </div>

        <div className="question-content question-with-content question-extra-render">
          {props.extraRender ? props.extraRender() : null}
          {tempQuestions.length !== 0 ? (
            <QuestionList
              data={tempQuestions}
              onRemove={removeQuestion}
              onClick={() => setIsQuestionModalOpen(true)}
            />
          ) : (
            <QuestionAddButton onClick={() => setIsQuestionModalOpen(true)} />
          )}
        </div>
      </Card>
      <Modal
        open={isQuestionModalOpen}
        destroyOnClose
        onCancel={() => setIsQuestionModalOpen(false)}
        closeIcon={null}
        styles={{ body: { padding: 0 }, content: { padding: 0 } }}
        width={1000}
        footer={null}
        maskClosable={false}
      >
        <SurveyQuestionModalContent
          value={tempQuestions}
          partialUpdateQuestions={() =>
            props.partialUpdateQuestions(() => {
              setIsQuestionModalOpen(false);
              showMessage('The questions has updated successfully', 'success');
            })
          }
          onChange={() => {
            setIsQuestionModalOpen(false);
          }}
        />
      </Modal>
    </Fragment>
  );
}

export { AddQuestion };
